export default __webpack_public_path__ + "static/media/elastic.50379afb.jpg";